import React, { useState } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { LeftButton, RightButton, SanityImage } from 'components';
import { Carousel } from 'react-responsive-carousel';
import { getAltTagFromFileName } from 'utils';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

function SingleColumnCarousel({
  images,
  imageWidth,
  imageHeight,
  imageTitle,
  setCurrentSpotlightIndex,
  showIndicators = false,
  markdownImages
}) {
  const numberOfImages = images ? images.filter((image) => image?.asset).length : 0;
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <section className="fade-in">
      <StyledCarousel
        infiniteLoop
        autoPlay={numberOfImages > 1}
        onChange={(index) => {
          if (setCurrentSpotlightIndex) {
            setCurrentSpotlightIndex(index);
          }
          setCurrentSlide(index);
        }}
        selectedItem={currentSlide}
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        showIndicators={showIndicators && numberOfImages > 1}
        interval={5000}
        transitionTime={500}
        preventMovementUntilSwipeScrollTolerance
        swipeScrollTolerance={50}>
        {images
          .filter((image) => image?.asset)
          .map((image) =>
            markdownImages ? (
              <GatsbyImage
                key={image.asset._id}
                image={image.asset.gatsbyImageData}
                alt={getAltTagFromFileName(image.asset.originalFilename)}
                loading="eager"
              />
            ) : (
              <SanityImage
                key={image.asset._id}
                title={imageTitle}
                image={image}
                width={imageWidth}
                height={imageHeight}
                alt={getAltTagFromFileName(image.asset.originalFilename)}
              />
            )
          )}
      </StyledCarousel>
      {numberOfImages > 1 && (
        <CarouselControls>
          <LeftButton
            onClick={() => setCurrentSlide((_currentSlide) => _currentSlide - 1)}
            disabled={currentSlide === 0}
          />
          <RightButton
            onClick={() => setCurrentSlide((_currentSlide) => _currentSlide + 1)}
            disabled={currentSlide === numberOfImages - 1}
            style={{
              left: `${numberOfImages * 10 + (numberOfImages - 1) * 8 + 20}px`
            }}
          />
        </CarouselControls>
      )}
    </section>
  );
}

const StyledCarousel = styled(Carousel)`
  .carousel.carousel-slider {
    overflow: inherit !important;
  }

  .control-dots {
    bottom: -2.875rem !important;
    display: flex !important;
    justify-content: center !important;
    left: 3.125rem !important;
    margin: 0 !important;
    width: unset !important;
    z-index: 1;

    .dot {
      background: #c9c9c9 !important;
      border: 0.125rem solid #c9c9c9 !important;
      box-shadow: none !important;
      display: list-item !important;
      height: 0.625rem !important;
      list-style: none !important;
      margin: 0 0.5rem 0 0 !important;
      opacity: 0.6 !important;
      outline: 0 !important;
      transition:
        background 0.25s,
        border 0.25s,
        opacity 0.25s !important;
      width: 0.625rem !important;

      &.selected {
        background: var(--connolly-red) !important;
        border: 0.125rem solid var(--connolly-red) !important;
        opacity: 1 !important;
      }
    }
  }
`;

const CarouselControls = styled.div`
  margin-top: 1.25rem;
`;

export default SingleColumnCarousel;
